export { default } from './getThemeProps';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/getThemeProps/index.js
// module id = 613
// module chunks = 121